/**
 * Objet DayJS.
 * 
 * @typedef {import('dayjs')} dayjs
 */

/**
 * Objet Horaires.
 * 
 * @typedef {Object} Horaires
 * @property {Object.<string, {endDate: Date, startDate: Date}>}
 */

/**
 * Objet Creneau.
 * 
 * @typedef {Object} Creneau
 * @property {string} id ID du créneau.
 * @property {string} [semaine] ID de la semaine.
 * @property {Array<string>} equipe Salariés du créneau.
 * @property {boolean} [heure] Est-ce que le créneau est une heure.
 * @property {string} [week] Lundi de la semaine au format YYYYMMDD.
 * @property {dayjs|Date|string} endDate Date de fin du créneau (dayjs, Date ou string au format ISO 8601).
 * @property {dayjs|Date|string} startDate Date de début du créneau (dayjs, Date ou string au format ISO 8601).
 */

/**
 * Objet PDF.
 * 
 * @typedef {Object} PDF
 * @property {number} send Valeur de l'envoi du planning (0 pour téléchargement, 1 pour envoi par mail).
 * @property {string} week Lundi de la semaine au format YYYYMMDD.
 * @property {string} fin Date de fin de la semaine au format YYYY-MM-DD.
 * @property {string} debut Date de début de la semaine au format YYYY-MM-DD.
 * @property {Object} amplitude L'amplitude horaire du planning.
 * @property {number} amplitude.minimum Horaire minimum du planning.
 * @property {number} amplitude.maximum Horaire maximum du planning.
 * @property {Array<string>} filter Salariés à afficher dans le planning.
 * @property {Array<string>} gmt Liste des GMT de chaque jour de la semaine.
 * @property {Array<string>} [users] (si value.send = 1) Liste des salariés destinataires du mail.
 * @property {Array<{user: string, heure: number, creneau: string}>} absents Liste des salariés absents.
 * @property {number} absents[].heure Est-ce que le créneau est une heure.
 * @property {string} absents[].creneau ID du créneau.
 * @property {string} absents[].user ID du salarié.
 */
